module.exports = __webpack_public_path__ + "img/JAOC_POP_TomatoSauce_round.b77d8e53.png";